import stylesheet from './CardGridInfoTileGroup.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

class NXTCardGridInfoTileGroup extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('info-tile-group');
        element.innerHTML = '<slot></slot>';
        return element;
    }
}

customElements.define('nxt-card-grid-info-tile-group', NXTCardGridInfoTileGroup);
